import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import biostone from "../../Assets/Projects/biostonepor.png";
import php from "../../Assets/Projects/php.png";  
import anatomie from "../../Assets/Projects/anatomie.png";  
import recomandation from "../../Assets/Projects/recomandation.png";  





import bitsOfCode from "../../Assets/Projects/blog.png"; 
import SAE from "../../Assets/Projects/SAE.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
        Projets  <strong className="purple">Récents </strong>
        </h1>
        <p style={{ color: "white" }}>
        Voici quelques projets sur lesquels j'ai travaillé récemment.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>







        <Col md={4} className="project-card">
  <ProjectCard
    imgPath={biostone}
    isBlog={false}
    title="Stage Biostone Marbrerie "
    description={
      <>
Stage Développeur Full Stack – BioStone Marbre (Mars à Juillet 2025)          
Développement d'une application web de gestion de stock industriel : architecture MVC en PHP, traçabilité via graphiques dynamiques (Chart.js), authentification sécurisée, gestion des fichiers uploadés avec vérifications côté client/serveur. 

<span style={{ color: '#E34F26' }}> Stack : </span>
            <span style={{ color: '#E34F26' }}> SQL, PostgreSQL, Git</span> et 
            <span style={{ color: '#E34F26' }}>  PHP, JavaScript, </span>, 
          </>
    }
    ghLink="https://drive.google.com/drive/folders/1Lfv4IfA93pprPU3EkkZwYp8ivE6qEhQb"
    demoLink="https://biostone.ma"

  />
</Col>

<Col md={4} className="project-card">
  <ProjectCard
    imgPath={suicide}
    isBlog={false}
    title=" Stage chez LaMSN Website Project"
    description={
      <>
        Explorez le site web de LaMSN,  un hub pour les passionnés de sciences numériques. Découvrez les dernières nouvelles, des cours interactifs et des projets innovants. Conçu avec HTML, CSS, JavaScript, React.js et
      <span style={{ color: '#E34F26' }}> SQL</span> pour une expérience utilisateur immersive.
    </>
    }
    ghLink="https://github.com/lakrafli/Site-web-du-laboratorie-de-recherche-La-Maison-Des-Sciences-Num-rique-"
    demoLink="https://lamsn.fr/index.html"

  />
</Col>






<Col md={4} className="project-card">
  <ProjectCard
    imgPath={anatomie}
    isBlog={false}
    title="Anatomiee-Interactive   "
    description={
      <>
Un site web interactif basé sur une image anatomique. Les utilisateurs peuvent cliquer sur différentes parties du corps pour voir apparaître des informations détaillées (nom de l’organe, fonction, pathologies)           
onçu avec 
        <span style={{ color: '#E34F26' }}> JS</span> et 
            <span style={{ color: '#E34F26' }}> HTML/CSS</span>, </>
    }
    ghLink="https://github.com/lakrafli/Anatomiee-Interactive "
    demoLink="https://lakrafli.github.io/Anatomiee-Interactive/"

  />
</Col>




<Col md={4} className="project-card">
  <ProjectCard
    imgPath={recomandation}
    isBlog={false}
    title="Projet - Recommandations de santé"
    description={
      <>
        Le but de ce projet était de développer une application web permettant
        d’afficher des recommandations de santé selon différents critères :
        catégorie, sous-catégorie et public ciblé. Le projet repose sur une
        <span style={{ color: '#61DAFB' }}> API REST</span> développée avec des
        données issues d’un fichier JSON local, construites à partir des
        recommandations officielles du PNNS.
        <br />
        Le front-end permet à l’utilisateur de filtrer dynamiquement les
        recommandations avec <span style={{ color: '#F7DF1E' }}>fetch()</span>,
        sans rechargement de la page.
      </>
    }
    ghLink="https://github.com/lakrafli/Recommandations-de-Sant-"
    demoLink="https://lakrafli.github.io/Recommandations-de-Sant-/"

  />
</Col>






        <Col md={4} className="project-card">
  <ProjectCard
    imgPath={leaf}
    isBlog={false}
    title=" The Magic Slate of Farida (Java)"
    description={
      <>
        Le but de ce projet était de développer une application  
        <span style={{ color: '#E34F26' }}> Java</span> pour gérer une ardoise virtuelle où diverses formes géométriques peuvent être stockées et affichées, en incorporant des concepts tels que l'héritage, la redéfinition de méthode et le polymorphisme.
        </>
    }
    ghLink="https://github.com/lakrafli/SAE_Java2.01"
  />  
</Col>



 


<Col md={4} className="project-card">
  <ProjectCard
    imgPath={editor}
    isBlog={false}
    title="Python Project: Implementation of the Brélaz Algorithm"
    description={
      <>
        Création d'une application Python utilisant l'algorithme de Brélaz pour la coloration de graphes, illustrant des concepts complexes en algorithmique. Utilisation de
        <span style={{ color: '#E34F26' }}>  Python</span>,
        <span style={{ color: '#E34F26' }}>  Numpy</span>, 
        <span style={{ color: '#E34F26' }}>  Matplotlib</span>, 
        <span style={{ color: '#E34F26' }}>  Seaborn</span>,
        <span style={{ color: '#E34F26' }}>  Pandas</span>, 
        <span style={{ color: '#E34F26' }}>  SciPy</span>.


      </>
    }
    ghLink="https://github.com/lakrafli/SAE_BUT_1/tree/main/Semestre%202/Algortithe-de-limites-central-python--main"
    demoLink="https://github.com/lakrafli/SAE_BUT_1/blob/main/Semestre%202/Algortithe-de-limites-central-python--main/Project%20Version%20finale_1.ipynb"              
  />
</Col>


















<Col md={4} className="project-card">

<ProjectCard
    imgPath={php}
    isBlog={false}
    title=" Développement d’une application asynchrone (PHP)"
    description={
      <>
        Le but de ce projet était de développer une application  
        <span style={{ color: '#E34F26' }}> TypeScript, Deno, Neo4j, Cypher</span> pour gérer une ardoise virtuelle où diverses formes géométriques peuvent être stockées et affichées, en incorporant des concepts tels que l'héritage, la redéfinition de méthode et le polymorphisme.
        </>
    }
    ghLink="https://github.com/kenzahatem/PHP403"
    demoLink="https://www.youtube.com/watch?v=wXQ-w2H56xo"
  />  
</Col>





<Col md={4} className="project-card">
  <ProjectCard
    imgPath={SAE}
    isBlog={false}
    title="Tactic Vision's Dynamic Website "
    description={
      <>
            Découvrez le pouvoir du nouveau site web de Perform Vision conçu pour connecter les entraîneurs avec facilité. Conçu avec 
            <span style={{ color: '#E34F26' }}> PHP</span>, 
            <span style={{ color: '#E34F26' }}> JS</span> et 
            <span style={{ color: '#E34F26' }}> HTML/CSS</span>, c'est la plateforme ultime pour les entraîneurs pour présenter leurs services sans effort.
          </>
    }
    ghLink="https://drive.google.com/drive/folders/1Lfv4IfA93pprPU3EkkZwYp8ivE6qEhQb"
  />
</Col>






          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="restaurant website"
              description="Je suis fier de vous présenter mon site web que j'ai créé en utilisant HTML, CSS et JavaScript. C'est une plateforme unique qui combine à la fois la restauration rapide et l'apprentissage culinaire. Après trois semaines de codage intensif, voici le résultat final."
              ghLink="https://github.com/lakrafli/Site-restauration.github"
              demoLink="https://lakrafli.github.io/Site-restauration.github/  "  
            />
          </Col>

         



          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title=" wedding website"
              description="Ce site web de mariage a été conçu en utilisant CSS3 et HTML5, complété par un peu de développement JavaScript. Il marque ma première aventure dans le développement web."
              ghLink="https://github.com/lakrafli/Site-de-Mariage"
              demoLink="https://lakrafli.github.io/Site-de-Mariage/"
            />
          </Col>
        




          

          <Col md={4} className="project-card">
  <ProjectCard
    imgPath={emotion}
    isBlog={false}
    title="My Portfolio"
    description={
      <>
            Bienvenue sur mon portfolio, une vitrine de mes compétences et projets où la technologie et la créativité se rencontrent. Ce projet a été réalisé en utilisant les technologies suivantes : <br/>
            <span style={{ color: '#E34F26' }}> React.js</span> ,  
        <span style={{ color: '#E34F26' }}> Node.js</span> , 
        <span style={{ color: '#E34F26' }}> Express.js</span> and 
        <span style={{ color: '#E34F26' }}>   Vercel</span>.
      </>
    }
  />
</Col>







         
          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
